import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { compose } from 'redux';
import { AUTHENTICATION_SCOPES } from '@playbookux/playbook-web-core';

import { signOut } from '../../actions';

const NotFound = (props) => {
  const { scope, onSignOut } = props;

  useEffect(() => {
    if (scope !== AUTHENTICATION_SCOPES.USER) {
      onSignOut();
    }
  }, [scope, onSignOut]);

  return (
    <Redirect to="/" />
  );
};

NotFound.propTypes = {
  scope: PropTypes.string.isRequired,
  onSignOut: PropTypes.func.isRequired,
};

const mapStateToProps = ({ authentication }) => ({
  scope: authentication.scope,
});

const mapDispatchToProps = {
  onSignOut: signOut,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
)(NotFound);
